import { render, staticRenderFns } from "./SelectLocation.vue?vue&type=template&id=54cf1971&scoped=true&"
import script from "./SelectLocation.vue?vue&type=script&lang=js&"
export * from "./SelectLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cf1971",
  null
  
)

export default component.exports